import React, { Component } from 'react'
import Body from './Body'
import MobileBody from './MobileBody'
import Footer from './Footer'
import Header from './Header'
import StartBuildingButton from './StartBuildingButton'
import { withRouter } from 'react-router-dom'
import './style.css'
import 'styles/breakpoints.css'


const GetBuildingText = () => (
  <span className="public-home-hero-back-text">
    Get Building
  </span>
)

const HeroText = () => (
  <span className="public-home-hero-text">
    Dev.Drift
  </span>
)

const HeroSubtitle = () => (
  <span className="public-home-hero-subtitle">
    <p>Build for just your business, or for all of Drift&#39;s users</p>
  </span>
)

class PublicHome extends Component {
  render() {
    return (
      <div className="home">
        <div className="public-home-hero-section">
          <Header className="public-home-top-menu" />
          <GetBuildingText />
          <HeroText />
          <HeroSubtitle />
          <StartBuildingButton
            className="hero-start-building-button"
            size="medium"
          />
        </div>
        <Body />
        <MobileBody />
        <Footer />
      </div>
    )
  }
}

export default withRouter(PublicHome)
